import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ConciergeServiceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ConciergeServiceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.492 21.3153L20.6676 17.0988C20.467 16.0726 19.7279 15.2247 18.7386 14.8859L15.0134 13.6102V13.3177C15.8184 12.6593 16.3852 11.7202 16.563 10.6512H16.8986C17.9773 10.6512 18.8548 9.7737 18.8548 8.69507V8.48842C18.8548 7.40979 17.9773 6.53226 16.8986 6.53226H16.6226V2.57135C16.6226 2.24725 16.3598 1.9845 16.0357 1.9845H8.46191C8.13781 1.9845 7.87506 2.24725 7.87506 2.57135V6.74263H7.59901C6.52038 6.74263 5.64285 7.62016 5.64285 8.69879V8.90544C5.64285 9.98407 6.52038 10.8616 7.59901 10.8616H7.97498C8.19247 11.8614 8.75275 12.7346 9.52633 13.3515V13.6048L5.79879 14.8853C4.81093 15.2247 4.07279 16.0722 3.87236 17.0973L3.04764 21.3153C2.98543 21.6333 3.19287 21.9416 3.51098 22.0038C3.54901 22.0113 3.58688 22.0149 3.62424 22.0149C3.89928 22.0149 4.14481 21.8206 4.19955 21.5405L5.02427 17.3225C5.14453 16.7075 5.58741 16.199 6.18009 15.9954L9.67051 14.7964C9.82329 15.0264 10.2258 15.5517 10.9043 15.8989L8.68781 17.4385C8.52991 17.5481 8.43578 17.7282 8.43578 17.9204V21.4287C8.43578 21.7528 8.69853 22.0156 9.02263 22.0156C9.34673 22.0156 9.60948 21.7528 9.60948 21.4287V18.2273L12.4929 16.2244C13.8965 16.1414 14.6382 15.1692 14.8697 14.8016L18.3583 15.9962C18.9519 16.1995 19.3954 16.7082 19.5157 17.324L20.3401 21.5405C20.3949 21.8206 20.6404 22.0149 20.9155 22.0149C20.9528 22.0149 20.9907 22.0113 21.0287 22.0038C21.3468 21.9417 21.5542 21.6334 21.492 21.3153ZM16.8986 7.70595C17.3301 7.70595 17.6811 8.05696 17.6811 8.48841V8.69506C17.6811 9.12651 17.3301 9.47752 16.8986 9.47752H16.6226V7.70594L16.8986 7.70595ZM9.04876 3.15819H15.4489V5.35077H9.04876V3.15819ZM6.81659 8.90543V8.69878C6.81659 8.26733 7.1676 7.91632 7.59905 7.91632H7.8751V9.6879H7.59905C7.1676 9.6879 6.81659 9.33688 6.81659 8.90543ZM9.04876 9.93124V6.52451H15.4489V9.93124C15.4489 11.6956 14.0134 13.131 12.2486 13.131C10.4842 13.131 9.04876 11.6956 9.04876 9.93124ZM12.3003 15.0569C11.408 15.0569 10.8854 14.4759 10.7001 14.223V14.1023C10.7037 14.0763 10.7056 14.0499 10.7056 14.0233C11.1858 14.2049 11.706 14.3047 12.249 14.3047C12.807 14.3047 13.3409 14.1995 13.832 14.0081C13.8307 14.0472 13.8333 14.086 13.8397 14.1239V14.2361C13.6766 14.4776 13.1921 15.0569 12.3003 15.0569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ConciergeServiceIcon;
